// Libraries
import { VictoryArea } from 'victory';
// Types
import { VictoryAreas } from './VictoryAreas.types';
// Utils
import { areaVariations } from '@theme/victory';

/**
 * Renders VictoryArea components based on the provided VictoryAreas data.
 *
 * @function
 * @param {VictoryAreas} victoryAreas - The data representing multiple areas to be rendered on the chart.
 * @returns {ReactElement[]} - An array of React elements representing the rendered VictoryAreas.
 *
 * @example
 * const data = [
 *   { x: 1, y: 10 },
 *   { x: 2, y: 15 },
 *   { x: 3, y: 12 },
 *   //...
 * ];
 *
 * const areas = [
 *   { rate: 'area1', data: data, styleKey: 'A' },
 *   { rate: 'area2', data: data, styleKey: 'B' },
 *   //...
 * ];
 *
 * const renderedAreas = renderVictoryAreas(areas);
 * // Returns an array of React elements representing the rendered VictoryAreas.
 * Important Note: This implementation relies on the Victory library, which does not
 * support creating this
 * component as a separate module due to potential injection vulnerabilities. Please avoid
 * using this
 * function where possible.
 *
 * For more information, refer to the documentation:
 * https://formidable.com/open-source/victory/docs
 */
export const renderVictoryAreas = (victoryAreas: VictoryAreas) =>
  victoryAreas.map(({ key, data, styleKey }) => {
    return <VictoryArea key={key} name={key} data={data} style={areaVariations[styleKey]} />;
  });
